import { ChatMessageItem, NewAdminChatMessage } from '../../graphql/API';
import { venueSendAdminChatMessage } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueSendAdminChatMessageApi = async (input: NewAdminChatMessage): Promise<ChatMessageItem> => {
  const result = await executeGql(venueSendAdminChatMessage, { input });
  return processGqlResult<ChatMessageItem>('venueSendAdminChatMessage', result);
};
